import { useEffect, useState } from 'react'
import { platformApi } from '../api'

/** Number of items waiting on the signed-in user; refreshed periodically. */
export function useInboxCount(enabled: boolean): number {
    const [n, setN] = useState(0)
    useEffect(() => {
        if (!enabled) return
        let live = true
        const load = () => platformApi.inbox().then((i) => { if (live) setN(i.length) }).catch(() => {})
        load()
        const t = setInterval(load, 60_000)
        return () => { live = false; clearInterval(t) }
    }, [enabled])
    return n
}
